import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import './Feedback.css';

const Feedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // État pour le tri
  const [sortOrder, setSortOrder] = useState(() => {
    return localStorage.getItem('feedbackSortOrder') || 'desc';
  });

  // Sauvegarder la préférence de tri
  useEffect(() => {
    localStorage.setItem('feedbackSortOrder', sortOrder);
  }, [sortOrder]);

  const handleDelete = async (feedbackId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce feedback ?')) {
      try {
        const db = getFirestore();
        await deleteDoc(doc(db, 'feedbacks', feedbackId));
        setFeedbacks(prevFeedbacks => prevFeedbacks.filter(feedback => feedback.id !== feedbackId));
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        alert('Une erreur est survenue lors de la suppression');
      }
    }
  };

  const markAsRead = async (feedbackId) => {
    try {
      const db = getFirestore();
      const feedbackRef = doc(db, 'feedbacks', feedbackId);
      await updateDoc(feedbackRef, {
        read: true
      });
    } catch (error) {
      console.error('Erreur lors du marquage comme lu:', error);
    }
  };

  const fetchFeedbacks = async () => {
    try {
      setLoading(true);
      const db = getFirestore();
      const feedbacksRef = collection(db, 'feedbacks');
      const snapshot = await getDocs(feedbacksRef);
      const feedbacksList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Marquer tous les feedbacks non lus comme lus
      for (const feedback of feedbacksList) {
        if (!feedback.read) {
          await markAsRead(feedback.id);
        }
      }
      
      setFeedbacks(feedbacksList);
    } catch (error) {
      console.error("Erreur lors de la récupération des feedbacks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  // Ajouter un écouteur d'événement pour le rafraîchissement
  useEffect(() => {
    const handleRefresh = () => {
      fetchFeedbacks();
    };

    window.addEventListener('refreshFeedback', handleRefresh);
    return () => window.removeEventListener('refreshFeedback', handleRefresh);
  }, []);

  // Trier les feedbacks par date
  const sortedFeedbacks = feedbacks.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
  });

  return (
    <div className="feedback">
      <div className="feedback-content">
        <div className="dashboard-container">
          <main className="main-content">
            <div className="content-header">
              <h1>Feedback</h1>
              <div className="header-actions">
                <div className="sort-filter">
                  <select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                    className="sort-select"
                  >
                    <option value="desc">Plus récent</option>
                    <option value="asc">Plus ancien</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="feedback-list">
              {loading ? (
                <div className="loading">
                  <i className="fas fa-spinner"></i>
                  Chargement...
                </div>
              ) : sortedFeedbacks.length === 0 ? (
                <div className="no-results">
                  <i className="far fa-comment-dots"></i>
                  Aucun feedback pour le moment
                </div>
              ) : (
                sortedFeedbacks.map(feedback => (
                  <div key={feedback.id} className="feedback-card">
                    <div className="feedback-header">
                      <div className="feedback-email">
                        <i className="far fa-envelope"></i>
                        {feedback.email}
                      </div>
                      <div className="feedback-actions">
                      <div className="feedback-date">
                          <i className="far fa-clock"></i>
                        {feedback.date ? feedback.date.replace(' UTC+1', '') : 'Date non disponible'}
                        </div>
                        <button
                          className="feedback-delete-btn"
                          onClick={() => handleDelete(feedback.id)}
                          title="Supprimer ce feedback"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                    <div className="feedback-message">
                      {feedback.message}
                    </div>
                  </div>
                ))
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Feedback; 